import React from 'react';
import './SimulacrumExplorerNavbar.css';
import {WalletMultiButton} from "@solana/wallet-adapter-react-ui";
import { Link, NavLink } from "react-router-dom";
import UserSolanaBalance from "./UserSolanaBalance";

function Navbar() {
    return (
        <div className="navbar">
            <div className="navbar-logo">
                <a href="https://thesimulacrum.xyz" target="_blank" rel="noopener noreferrer">
                    <img className="navbar-logo-image" src="/372.png" alt="The Simulacrum Microwave Logo"/>
                </a>
            </div>
            <div className="navbar-links">
                {/*<div className="navbar-link">*/}
                {/*    <NavLink*/}
                {/*        to="/mint-nft"*/}
                {/*        className={({ isActive }) => (isActive ? "active" : "")}*/}
                {/*    >*/}
                {/*        <p>Mint NFT</p>*/}
                {/*    </NavLink>*/}
                {/*</div>*/}
                <div className="navbar-link">
                    <NavLink
                        to="/"
                        className={({ isActive }) => (isActive ? "active" : "")}
                    >
                        <h3>Account Explorer</h3>
                    </NavLink>
                </div>
                {/*<div className="navbar-link">*/}
                {/*    <NavLink*/}
                {/*        to="/audio"*/}
                {/*        className={({ isActive }) => (isActive ? "active" : "")}*/}
                {/*    >*/}
                {/*        <h3>Audio Player</h3>*/}
                {/*    </NavLink>*/}
                {/*</div>*/}
                <div className="navbar-link">
                    <NavLink
                        to="/styles"
                        className={({ isActive }) => (isActive ? "active" : "")}
                    >
                        <h3>Style Shop</h3>
                    </NavLink>
                </div>
                <div className="navbar-link">
                    <NavLink
                        to="/about-crumb"
                        className={({ isActive }) => (isActive ? "active" : "")}
                    >
                        <h3>About</h3>
                    </NavLink>
                </div>
                <div className="navbar-link"><UserSolanaBalance/></div>
                <div className="navbar-link"><WalletMultiButton /></div>
            </div>
        </div>
    );
}

export default Navbar;